import React from "react";
import logo from "../../../assets/Logo.png";

const Logo = ({ className }: { className?: string }) => {
  return <img className={ className } src={ logo } alt="Logo" />;
};

export default Logo;
